import {
  ChangeDetectionStrategy,
  Component,
  Input,
  computed,
  signal,
} from '@angular/core';
import { MarkdownPipe, SonderAvatarComponent, type Message } from '@sondermind/ai-chat-angular';

@Component({
  selector: 'member-w9-agent-message-row',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MarkdownPipe, SonderAvatarComponent],
  styleUrls: ['./w9-agent-message-row.component.scss'],
  templateUrl: './w9-agent-message-row.component.html',
})
export class W9AgentMessageRowComponent {
  @Input({ required: true }) set message(v: Message) { this._message.set(v) }
  get message(): Message { return this._message() }
  @Input() providerInitials = '?';

  private readonly _message = signal<Message | null>(null);

  readonly isAssistant = computed(() => this._message()?.role === 'assistant');
  readonly isTyping = computed(() => this._message()?.status === 'assistant_pending');
}
